import { orderSliceActions } from 'app/pages/order/redux/order-slice';
import type { AppDispatch } from 'app/redux/types/types';
import { OrderStep } from 'app/pages/order/redux/model/order-step';

export const updateOrderStepActionCreator = (step: OrderStep) => (dispatch: AppDispatch) => {
    dispatch(orderSliceActions.updateOrderStep(step));
};
